module.exports = __webpack_public_path__ + "img/aquavieroundtrans.4ad99790.png";